const config = {
  firebase: {
    config: {
      apiKey: 'AIzaSyD1jT3jfTzOwU0Nvh22INTgOAaqgZpjH0g',
      authDomain: 'fds-dev-ff2ac.firebaseapp.com',
      databaseURL: 'https://fds-dev-ff2ac.firebaseio.com',
      projectId: 'fds-dev-ff2ac',
      storageBucket: 'fds-dev-ff2ac.appspot.com',
      messagingSenderId: '955805347603',
      appId: '1:955805347603:web:060c79aa2146f60201b4e6',
    },
    messaging: {
      publicKey: 'BChVLe0Tb5OfiOdouxit05eZCu7TlR9KBO8kLTlaB97H7jkKuspLq6uUQksopwVsYSI1Y2ttMLrstMbDP2jC9_c',
    },
    status: false,
  },
  api: {
    //url: 'http://localhost:3002',
    //url_auth: 'http://localhost:3002',
    //url_socket: 'http://localhost:3005',
    url: 'https://dev-apigateway.airpresense.tech',
    url_auth: 'https://dev-apigateway.airpresense.tech',
    url_socket: 'https://dev-notification.airpresense.tech',
    version: 'v3/api',
  },
  protocol: 'http',
  vconsole: {
    enabled: true,
  },
  groupNotification: true,
  cache: true,
  style: {
    useHN: false,
  },
  mapHiding: [35],
  configType: true,
  deviceMax: 2,
  battery: {
    hideBatteryAfter: 10, //1440
  },
  displayPlaceForEmergency: true,
  features: {
    report: {
      vitalSign: true,
      garmin: true,
    },
    dashboard: {
      roomName: true,
    },
    allPatients: {
      syncNirun: false,
    },
    sidebar: {
      dashboard: true,
      allPatients: true,
      device: true,
      deviceType: true,
      router: true,
      routerType: true,
      location: true,
      map: true,
      group: true,
      module: true,
      area: true,
      user: true,
      role: true,
      patient: true,
      alertProfile: true,
    },
    auth: {
      authMode: 'local', //cognito,local
    },
  },
  headerView: {
    default: 'Pre-Sense System',
  },
};
module.exports = config;
